/**
 * jQuery plugin to monitor scroll distance and add class to an element after document scrolls to a position.
 * This is used for sticky headers, primarily. The "scrolled" state can then be styled in CSS.
 *
 * @param $
 */
(function ($) {
	$.fn.scrollclass = function (options) {
		const opts = $.extend({}, $.fn.scrollclass.defaults, options);
		const $header = this;
		let state2 = false;

		$(document)
			.scroll(function () {
				const $this = $(this);

				if (false === state2 && $this.scrollTop() > opts.pos) {
					state2 = true;
					$header.addClass("scrolled");
					setTimeout(function () {
						$header.addClass("doscrolled");
					}, 250);
				} else if ($this.scrollTop() === 0) {
					state2 = false;
					$header.removeClass("doscrolled scrolled");
				}
			})
			.trigger("scroll");
	};

	// default options
	$.fn.scrollclass.defaults = {
		pos: 200,
	};
})(jQuery);

/**
 * Use scrollclass plugin on #site-header if it exists.
 */
jQuery(document).ready(function ($) {
	const $header = $("#site-header");
	if (0 < $header.length) {
		$header.scrollclass({
			pos: parseFloat($header.outerHeight()) + 50,
		});
	}
});
